<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Expense</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="editInvestForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12>
            <v-menu
              v-model="paymentDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editItem.payment_date"
                  label="Date *"
                  readonly
                  outline
                  required
                  :rules="requiredRules"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="editItem.payment_date"
                @input="paymentDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex sm12 class="pb-4">
            <v-autocomplete
              label="Investor Name *"
              v-model="editItem.investor_id"
              :items="investorsTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              outline
              label="Amount *"
              type="number"
              required
              v-model="editItem.amount"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>

          <v-flex sm12>
            <v-radio-group
              required
              v-model="editItem.method"
              row
              label="Payment Method: "
            >
              <v-radio
                :label="item.charAt(0).toUpperCase() + item.slice(1)"
                :value="item"
                v-for="(item, index) in PAYMENT_METHODS"
                :key="index"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs12 v-if="editItem.method == 'cheque'">
            <v-menu
              v-model="checkDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editItem.check_date"
                  label="Check Issued Date"
                  readonly
                  outline
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="editItem.check_date"
                @input="checkDateMenu = false"
              ></v-date-picker>
            </v-menu>

            <v-text-field
              outline
              label="Check Number"
              v-model="editItem.check_number"
            ></v-text-field>
            <v-text-field
              outline
              label="Bank Name"
              v-model="editItem.check_bank_name"
            ></v-text-field>
            <v-text-field
              outline
              label="Branch Name"
              v-model="editItem.check_bank_branch"
            ></v-text-field>
          </v-flex>
          <v-textarea v-model="editItem.notes" outline label="Notes"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Update</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { PAYMENT_METHODS } from "../../mdsir/const";
import { getTV, removeEmptyProps } from "../../mdsir/MdsirUtils";

export default {
  props: ["editItem", "investorsTV"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      paymentDateMenu: false,
      checkDateMenu: false,
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    // validate() {
    //   if (this.$refs.editInvestForm.validate()) {
    //     this.snackbar = true;
    //   }
    // },
    // reset() {
    //   this.$refs.editInvestForm.reset();
    // },
    // resetValidation() {
    //   this.$refs.editInvestForm.resetValidation();
    // },
    editItemDo() {
      if (this.$refs.editInvestForm.validate()) {
        this.actionButtonClicked = true;
        this.put(
          "/investment",
          removeEmptyProps(this.editItem, ["check_date"])
        ).then((res) => {
          if (res.data.success) {
            this.$emit("updated", this.editItem);
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
  },
  mounted() {},
  created() {
    this.PAYMENT_METHODS = PAYMENT_METHODS;
  },
};
</script>
